// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QiWYH","content":"Footer_content__cQE2x","title":"Footer_title__ohJt8","contact":"Footer_contact__r9YWg"};